export const REVEAL_ATTRIBUTE = "data-reveal";
export const REVEALED_ATTRIBUTE = "data-revealed";

export const REVEAL_IMAGE_PROPS = {
    [REVEAL_ATTRIBUTE]: "",
    suppressHydrationWarning: true,
};

export const DOG_CARD_PHOTO_REVEAL_SCRIPT = `document.addEventListener("load", function (event) {
    var image = event.target;
    if (image instanceof HTMLImageElement && image.hasAttribute("${REVEAL_ATTRIBUTE}")) {
        image.setAttribute("${REVEALED_ATTRIBUTE}", "");
    }
}, true);`;
